<template lang="pug">
  div
    .common-modal(:class="{ open: AllJobMarkModal }")
      a.common-modal-close(@click="close")
        | 閉じる
      .common-modal-title
        | 事業所リストへの一括追加を開始します
      .common-modal-main
        .common-modal-main-inner
          p
            | 現在、
            | {{ mapCompanyCount }}
            | 件の企業情報を選択しています。
          p
            | ※選択している件数が多い場合、追加処理に時間がかかる可能性があります。
          p.common-modal-button(v-if="onMarking === 1")
            input.button-main(type="button", value="追加中・・・" :disabled="true")
          p.common-modal-button(v-else-if="onMarking === 0")
            input.button-main(type="button", value="一括追加" @click="allJobMark")
          p.common-modal-button(v-else-if="onMarking === 2")
            input.button-main(type="button", value="完了しました" :disabled="true")
    .modal-cover
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        AllJobMarkModal: 'map/AllJobMarkModal',
        onMarking: 'map/onMarking',
        mapCompanyCount: 'map/companyIdsCount',
      }),
      ...mapState({
        user: state => state.user.detail,
      }),
    },
    methods: {
      close () {
        this.$store.commit('map/hideModal')
        this.$store.commit('map/setOnMarkingStart')
      },
      ...mapActions('jobMark', ['add', 'remove']),
      async allJobMark () {
        const companyIds = []
        this.$store.state.map.index.forEach((company) => {
          if (!company.in_job_mark) {
            companyIds.push(company.id)
          }
        })

        try {
          this.$store.commit('common/lockGlobal')
          this.$store.commit('map/setOnMarking')

          if (companyIds.length) {
            await this.add({ id: companyIds })
          }

          this.$store.state.map.index.forEach((company) => {
            if (!company.in_job_mark) {
              this.$store.commit('map/changeJobMark', { value: !company.in_job_mark, companyId: company.company_id, user: this.user })
              const markButtonList = document.getElementById(`markButtonList${company.company_id}`)

              markButtonList.classList.add('on')
            }
          })
          this.createinfoWindow()
          this.$store.commit('common/unlockGlobal')
        } finally {
          this.$store.commit('map/setOnMarkingEnd')
        }
      },
      createinfoWindow () {
        this.$emit('createinfoWindow')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/AllJobMarkModal.vue